/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OrganisationPreferenceDto
 */
export interface OrganisationPreferenceDto {
    /**
     *
     * @type {string}
     * @memberof OrganisationPreferenceDto
     */
    organisationId?: string;
    /**
     *
     * @type {string}
     * @memberof OrganisationPreferenceDto
     */
    preferenceType?: OrganisationPreferenceDtoPreferenceTypeEnum;
    /**
     * The value of the preference for the organisation (or a default value if not set on the org, or null if no default)
     * @type {string}
     * @memberof OrganisationPreferenceDto
     */
    value?: string;
    /**
     * Timestamp of when the preference was last updated. Null if never updated (ie using default value or no value)
     * @type {Date}
     * @memberof OrganisationPreferenceDto
     */
    updatedAt?: Date;
}

/**
 * @export
 */
export const OrganisationPreferenceDtoPreferenceTypeEnum = {
    Unknown: "Unknown",
    IncludeOfflineInUptimeCalculation: "IncludeOfflineInUptimeCalculation",
    LowEnergyDeliveryAcKwhThreshold: "LowEnergyDeliveryAcKwhThreshold",
    LowEnergyDeliveryDcKwhThreshold: "LowEnergyDeliveryDcKwhThreshold",
    LowEnergyDeliveryAcMinutesThreshold: "LowEnergyDeliveryAcMinutesThreshold",
    LowEnergyDeliveryDcMinutesThreshold: "LowEnergyDeliveryDcMinutesThreshold",
} as const;
export type OrganisationPreferenceDtoPreferenceTypeEnum =
    (typeof OrganisationPreferenceDtoPreferenceTypeEnum)[keyof typeof OrganisationPreferenceDtoPreferenceTypeEnum];

/**
 * Check if a given object implements the OrganisationPreferenceDto interface.
 */
export function instanceOfOrganisationPreferenceDto(
    value: object,
): value is OrganisationPreferenceDto {
    return true;
}

export function OrganisationPreferenceDtoFromJSON(
    json: any,
): OrganisationPreferenceDto {
    return OrganisationPreferenceDtoFromJSONTyped(json, false);
}

export function OrganisationPreferenceDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OrganisationPreferenceDto {
    if (json == null) {
        return json;
    }
    return {
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        preferenceType:
            json["preferenceType"] == null ? undefined : json["preferenceType"],
        value: json["value"] == null ? undefined : json["value"],
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
    };
}

export function OrganisationPreferenceDtoToJSON(
    value?: OrganisationPreferenceDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        organisationId: value["organisationId"],
        preferenceType: value["preferenceType"],
        value: value["value"],
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
    };
}
